// 运行配置：与原 UniApp/Vite 版本的 VITE_* 变量一一对应，Vue CLI 使用 VUE_APP_* 前缀。
const env = process.env || {}

function flag(value) {
  return String(value || '').toLowerCase() === 'true'
}

// 未显式配置接口地址时回落到同源地址：开发时由 vue.config.js 的 devServer 代理转发，
// 上线时由 Nginx 把 /v1、/api 反代到后端。这样代码里不写死 IP，HTTPS 页面也不会被混合内容拦截。
function sameOrigin() {
  return typeof window !== 'undefined' && window.location ? window.location.origin : ''
}

export const config = Object.freeze({
  // demo：内置演示模板；real：读取后端公开目录/品牌接口
  customerMode: env.VUE_APP_CUSTOMER_MODE || 'real',
  authApiBase: env.VUE_APP_AUTH_API_BASE || sameOrigin(),
  catalogApiBase: env.VUE_APP_CATALOG_API_BASE || sameOrigin(),
  brandApiBase: env.VUE_APP_BRAND_API_BASE || sameOrigin(),
  adminApiBase: env.VUE_APP_ADMIN_API_BASE || sameOrigin(),
  // 开发环境下允许 http://localhost 直连后端；生产必须 https
  development: flag(env.VUE_APP_ALLOW_INSECURE_LOCAL)
    ? true
    : env.NODE_ENV !== 'production',
})

export default config
